import { render, staticRenderFns } from "./AddressFormatterFunctional.vue?vue&type=template&id=68f22dfb&functional=true"
import script from "./AddressFormatterFunctional.vue?vue&type=script&lang=js"
export * from "./AddressFormatterFunctional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports